import React from 'react'
import { NavLink } from 'react-router-dom'
import { FiBell, FiUser } from 'react-icons/fi'

const TABS = [
  {
    id: 'notifications',
    label: 'Notifications',
    path: '/user/profile',
    isActive: (match, location) =>
      Boolean(match) || ['/user', '/user/'].includes(location.pathname),
    hasBadge: true,
    icon: <FiBell size={18} />,
  },
  {
    id: 'profile',
    label: 'Edit Profile',
    path: '/user/update',
    icon: <FiUser size={18} />,
  },
  {
    id: 'security',
    label: 'Security',
    path: '/user/change-password',
    icon: (
      <svg
        width='18'
        height='18'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <rect x='3' y='11' width='18' height='11' rx='2' ry='2' />
        <path d='M7 11V7a5 5 0 0 1 10 0v4' />
      </svg>
    ),
  },
  {
    id: 'addresses',
    label: 'Addresses',
    path: '/user/addresses',
    icon: (
      <svg
        width='18'
        height='18'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path d='M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z' />
        <circle cx='12' cy='10' r='3' />
      </svg>
    ),
  },
]

const QuickActions = ({ unreadCount = 0 }) => (
  <div className='quick-actions-wrapper'>
    <div className='quick-actions'>
      {TABS.map((tab) => (
        <NavLink
          key={tab.id}
          to={tab.path}
          id={`qa-${tab.id}`}
          className='quick-action'
          activeClassName='active'
          isActive={tab.isActive}
        >
          {tab.icon}
          <span>{tab.label}</span>
          {tab.hasBadge && unreadCount > 0 && (
            <span className='unread-badge' id='unread-count'>
              {unreadCount}
            </span>
          )}
        </NavLink>
      ))}
    </div>
  </div>
)

export default QuickActions
